import BitcoinMotivLogo from "./Assets/Img/Motiv_Final_logo_Bitcoin.png"
import Globant from "./Assets/Img/Globant.png"
import LetsBit from "./Assets/Img/letsbit.png"
import GoldenCapitalFx from "./Assets/Img/Golden-Capital-Fx.png"
import AgenteBTC from "./Assets/Img/agente-btc.png"
import beInCripto from "./Assets/Img/beInCripto.png"
import cointelegraph from "./Assets/Img/cointelegraph.png"
import diarioBitcoin from "./Assets/Img/diarioBitcoin.png"

// URLS
export const youtubeVideo =
  "https://www.youtube.com/embed/s7x_0htpM9M?autoplay=1&mute=1";

export const instagram = "https://www.instagram.com/lima.cripto/"

export const linkedin = "https://www.linkedin.com/company/lima-cripto/" 

export const mail = "mailto:hablemos@limacripto.com"

export const whatsapp = "https://api.whatsapp.com/send?phone=51956174788"

export const logo = "https://res.cloudinary.com/dubbcjkfa/image/upload/v1663807798/Lima-Cripto/LOGO_ufux8k.svg"

export const icon1 = "https://res.cloudinary.com/dubbcjkfa/image/upload/v1663001964/Lima-Cripto/icono-2_ywelvu.png"

export const icon2 = "https://res.cloudinary.com/dubbcjkfa/image/upload/v1663809191/Lima-Cripto/icon2_otov1x.png"

export const icon3 = "https://res.cloudinary.com/dubbcjkfa/image/upload/v1663809187/Lima-Cripto/icon3_wxsgo4.png"

// Video Component
export const videoTitle = "El evento más grande de Criptomonedas del Perú";

// About Component
export const aboutSubtitle = "Ya seas un emprendedor, desarrollador, innovador, o profesional disrumpiendo industrias, este evento es para ti."

export const aboutDescription = "BITCONF LATAM 2022 reúne a los principales agentes del ecosistema Cripto y Blockchain en Perú e Hispanoamérica con el fin de fomentar el nivel de adopción y sensibilización de la nueva economía digital. "

export const aboutArray = 
  [{url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100028/Lima-Cripto/lima-cripto_u0yk89.jpg", alt:"first slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654099511/Lima-Cripto/lima-cripto-2_r76ibk.jpg", alt:"second slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654099868/Lima-Cripto/lima-cripto-3_hfoaob.jpg", alt:"third slide"}
]

// Metrics Component
export const counterArray = [
  {number: 100, title: "Asistentes"}, 
  {number: 50, title: "Speakers"}, 
  {number: 30, title: "Horas de Contenido"}, 
  {number: 10, title: "Sponsors"}, 
]


// Agenda Component
export const firstDayArray = [
  {time: "8:00 AM",
  title: "Bienvenidos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",},

  {time: "9:00 AM",
  title: "Bienvenidos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",},

  {time: "8:00 AM",
  title: "Bienvenidos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",},

  {time: "8:00 AM",
  title: "Bienvenidos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",}
]

export const secondDayArray = [
  {time: "8:00 AM",
  title: "Regresamos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",},

  {time: "8:00 AM",
  title: "Bienvenidos a Bitconf Perú 2022",
  speaker: "Tyler Evans, Mayor Dan Gelber",},

]

// Events View
export const capitalArray = 
  [{url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101048/Lima-Cripto/278197915_1150916508992418_6269388733440744189_p0cscx.jpg", alt:"first slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101207/Lima-Cripto/278030024_1652659098428570_4561630751351052320_xmbbir.jpg", alt:"second slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101109/Lima-Cripto/277966680_2117315005108824_5835082380905633189_cfuoyi.jpg", alt:"third slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101208/Lima-Cripto/278124130_397603045547417_1951398451414497734_a6q5te.jpg", alt:"four slide"}]

  export const fuckupNightsArray = 
  [{url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101289/Lima-Cripto/FUCKUP-POST-PRINCIPAL_zzx7ah.png", alt:"first slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101383/Lima-Cripto/RENZO-PECHE_isxpvi.png", alt:"second slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101450/Lima-Cripto/VICTOR-EGOAVIL_xcnisu.png", alt:"third slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101586/Lima-Cripto/VALENTIN-POPESCU_mzo4q4.png", alt:"four slide"},
  {url:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654101580/Lima-Cripto/RENATO-DE-LA-ROSA_yzszcx.png", alt:"five slide"}]

  // Press View 

  export const newsArray = [
    {
      logo:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654038892/Lima-Cripto/avatar-barragan-140x140_srudiy.png",
      title: "Se realizó con mucho éxito la conferencia Lima Cripto Capital",
      author: "Por Luis Barragán, Alerta Económica",
      description: "La semana pasada se realizó en Lima la primera conferencia de criptomonedas en el país, la cual contó con la participación de expertos internacionales y la asistencia de más de 500 ejecutivos...",
      link: "https://alertaeconomica.com/se-realizo-con-mucho-exito-la-conferencia-lima-cripto-capital/",
      share: "https://www.linkedin.com/shareArticle?mini=true&url=https%3A//alertaeconomica.com/se-realizo-con-mucho-exito-la-conferencia-lima-cripto-capital/&title=Se%20realiz%C3%B3%20con%20mucho%20%C3%A9xito%20la%20conferencia%20Lima%20Cripto%20Capital&summary=&source=",
      image: "https://res.cloudinary.com/dubbcjkfa/image/upload/v1654037755/Lima-Cripto/limacripto_tmabmp.png"
    },

    {
      logo:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654044761/Lima-Cripto/hannah_avatar_48x48_ght21y.jpg",
      title: "Evento ‘Lima Cripto Capital’, criptomonedas y Blockchain",
      author: "Por Hannah Pérez, Diario Bitcoin ",
      description: "Más de 20 especialistas participarán de la conferencia, que se realizará entre el 29 y 30 de abril. Los interesados podrán acudir de forma presencial o virtual. Conozca más del evento a continuación. ",
      link: "https://www.diariobitcoin.com/eventos/lima-cripto-capital-analizara-uso-de-criptomonedas-y-blockchain-en-peru/",
      share: "https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.diariobitcoin.com/eventos/lima-cripto-capital-analizara-uso-de-criptomonedas-y-blockchain-en-peru/&title=Evento%20%E2%80%98Lima%20Cripto%20Capital%E2%80%99%20reunir%C3%A1%20a%20expertos%20para%20analizar%20uso%20de%20criptomonedas%20y%20Blockchain%20en%20Per%C3%BA%20y%20Latinoam%C3%A9rica&summary=&source=",
      image: "https://res.cloudinary.com/dubbcjkfa/image/upload/v1654044684/Lima-Cripto/lima-crpto-capital-min_cme9yi.jpg"
    },

    {
      logo:"https://res.cloudinary.com/dubbcjkfa/image/upload/v1654045483/Lima-Cripto/32_aHR0cHM6Ly9zMy5jb2ludGVsZWdyYXBoLmNvbS9zdG9yYWdlL3VwbG9hZHMvdmlldy9hMjBiNzk1ODk1NDQ0OGZmY2QyZjg3NGU1ZDlkYjE5Zi5qcGc_ptjqjd.jpg",
      title: "Expertos se reúnen para analizar el uso de blockchain",
      author: "Por César Patiño Burgos, Cointelegraph ",
      description: "Actualmente, hay un gran interés en organizar y asistir a eventos sobre la tecnología blockchain y otros desarrollos del sector. A finales del mes, el 29 y 30 de abril se realizará la conferencia Lima Cripto Capital...",
      link: "https://es.cointelegraph.com/news/experts-from-around-the-world-gather-in-lima-to-discuss-the-use-of-blockchain-and-the-use-case-for-a-digital-currency-for-peru",
      share: "https://www.linkedin.com/shareArticle?mini=true&url=https%3A//es.cointelegraph.com/news/experts-from-around-the-world-gather-in-lima-to-discuss-the-use-of-blockchain-and-the-use-case-for-a-digital-currency-for-peru&title=Expertos%20de%20todo%20el%20mundo%20se%20re%C3%BAnen%20en%20Lima%20para%20analizar%20el%20uso%20de%20blockchain%20y%20el%20caso%20de%20uso%20de%20una%20moneda%20digital%20para%20el%20Per%C3%BA&summary=&source=",
      image: "https://res.cloudinary.com/dubbcjkfa/image/upload/v1654045550/Lima-Cripto/648eb30e51fd34440b7f495e19ddf259_hjcyrn.jpg"
    }
  ]

  // Speakers Component
  export const itemData = [
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100282/Lima-Cripto/angelaocando_dcfsj0.webp',
      name: 'Angela Ocando',
      role: 'Directora de la Escuela de Blockchain y Criptomonedas en Platzi',
      linkedin: 'https://www.linkedin.com/in/angelaocando/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100534/Lima-Cripto/Dania_x2bcyc.jpg',
      name: 'Dania González',
      role: 'Diputada de la República de El Salvador',
      linkedin: 'https://www.linkedin.com/in/daniagonzalezsv/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100403/Lima-Cripto/Monica-taher_wegw2d.jpg',
      name: 'Monica Taher',
      role: 'Asesora de Tecnología y Finanzas',
      linkedin: 'https://www.linkedin.com/in/monicataher/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100470/Lima-Cripto/Marcos-Allende_zznytq.jpg',
      name: 'Marcos Allende',
      role: 'Líder Técnico LACChain',
      linkedin: 'https://www.linkedin.com/in/marcosallendel/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100282/Lima-Cripto/angelaocando_dcfsj0.webp',
      name: 'Angela Ocando',
      role: 'Directora de la Escuela de Blockchain y Criptomonedas en Platzi',
      linkedin: 'https://www.linkedin.com/in/angelaocando/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100534/Lima-Cripto/Dania_x2bcyc.jpg',
      name: 'Dania González',
      role: 'Diputada de la República de El Salvador',
      linkedin: 'https://www.linkedin.com/in/daniagonzalezsv/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100403/Lima-Cripto/Monica-taher_wegw2d.jpg',
      name: 'Monica Taher',
      role: 'Asesora de Tecnología y Finanzas',
      linkedin: 'https://www.linkedin.com/in/monicataher/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100470/Lima-Cripto/Marcos-Allende_zznytq.jpg',
      name: 'Marcos Allende',
      role: 'Líder Técnico LACChain',
      linkedin: 'https://www.linkedin.com/in/marcosallendel/'
    }
 
  ];

  // Speakers View

  export const speakerList = [
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100282/Lima-Cripto/angelaocando_dcfsj0.webp',
      name: 'Angela Ocando',
      role: 'Directora de la Escuela de Blockchain y Criptomonedas en Platzi',
      linkedin: 'https://www.linkedin.com/in/angelaocando/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100534/Lima-Cripto/Dania_x2bcyc.jpg',
      name: 'Dania González',
      role: 'Diputada de la República de El Salvador',
      linkedin: 'https://www.linkedin.com/in/daniagonzalezsv/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100403/Lima-Cripto/Monica-taher_wegw2d.jpg',
      name: 'Monica Taher',
      role: 'Asesora de Tecnología y Finanzas',
      linkedin: 'https://www.linkedin.com/in/monicataher/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100470/Lima-Cripto/Marcos-Allende_zznytq.jpg',
      name: 'Marcos Allende',
      role: 'Líder Técnico LACChain',
      linkedin: 'https://www.linkedin.com/in/marcosallendel/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100282/Lima-Cripto/angelaocando_dcfsj0.webp',
      name: 'Angela Ocando',
      role: 'Directora de la Escuela de Blockchain y Criptomonedas en Platzi',
      linkedin: 'https://www.linkedin.com/in/angelaocando/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100534/Lima-Cripto/Dania_x2bcyc.jpg',
      name: 'Dania González',
      role: 'Diputada de la República de El Salvador',
      linkedin: 'https://www.linkedin.com/in/daniagonzalezsv/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100403/Lima-Cripto/Monica-taher_wegw2d.jpg',
      name: 'Monica Taher',
      role: 'Asesora de Tecnología y Finanzas',
      linkedin: 'https://www.linkedin.com/in/monicataher/'
    },
    {
      img: 'https://res.cloudinary.com/dubbcjkfa/image/upload/v1654100470/Lima-Cripto/Marcos-Allende_zznytq.jpg',
      name: 'Marcos Allende',
      role: 'Líder Técnico LACChain',
      linkedin: 'https://www.linkedin.com/in/marcosallendel/'
    }
 
  ];

  // Sponsors Component
export const mediaPartners = [
{image:beInCripto , alt: "be In Cripto"},
{image:cointelegraph, alt: "cointelegraph"},
{image:diarioBitcoin, alt: "diario Bitcoin"}
]

  // Sponsors Categories
  export const BitcoinMotiv = BitcoinMotivLogo

  export const bitcoinSponsors = [
    {image: LetsBit, alt:"LetsBit"}, 
    {image: Globant, alt:"Globant"}, 
    {image: GoldenCapitalFx, alt:"GoldenCapitalFx"},
    {image: AgenteBTC, alt:"AgenteBTC"}
  ]
